import { render, staticRenderFns } from "./ExamProject.vue?vue&type=template&id=36018738&scoped=true"
import script from "./ExamProject.vue?vue&type=script&lang=js"
export * from "./ExamProject.vue?vue&type=script&lang=js"
import style0 from "./ExamProject.vue?vue&type=style&index=0&id=36018738&prod&lang=stylus&scoped=true"
import style1 from "./ExamProject.vue?vue&type=style&index=1&id=36018738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36018738",
  null
  
)

export default component.exports